import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {PbiTable, ReportLayout} from "./layout";
import {DropdownSlicer, ListSlicer} from "./slicers";
import useSlicers, {MONTH_OPTIONS} from "./slicer-state";
import useReport from "./use-report";
import {build_filters} from "./utils";

/** @module Pages/Reports/CentroCosto */

// Anchos de columna del visual del Power BI (px).
const WIDTHS = {centro_costo: 116, fecha_visita: 90, descripcion: 236, persona: 253};

/**
 * Página "Por centro de costo" del Power BI: segmentador de centro_costo, tabla de visitas y
 * segmentadores de Año y Mes a la derecha.
 */
const ReportCentroCosto = () => {
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const {slicers, set, yearOptions} = useSlicers(token);
    const filters = useMemo(() => build_filters({...slicers, nombre: null}), [slicers]);
    const {data, loading, error, loadMore} = useReport(token, "centro_costo", filters);

    return (
        <ReportLayout title="Por centro de costo" token={token} body={{type: "centro_costo", filters}}
                      loading={loading} error={error}>
            <div className="pbi-page pbi-page--centro">
                <div className="pbi-page__main">
                    <div className="pbi-page__top">
                        <DropdownSlicer title="centro_costo" field="centro_costo" token={token}
                                        value={slicers.centro} onChange={set("centro")}/>
                    </div>
                    <PbiTable data={data} widths={WIDTHS} loading={loading} onLoadMore={loadMore}/>
                </div>
                <div className="pbi-page__side">
                    <ListSlicer title="Año" options={yearOptions} value={slicers.year} onChange={set("year")}/>
                    <ListSlicer title="Mes" options={MONTH_OPTIONS} value={slicers.month} onChange={set("month")}/>
                </div>
            </div>
        </ReportLayout>
    );
};

export default ReportCentroCosto;
